// 좌표 기반 국내/해외 판정 (순수 함수)

// 한국 대략 bounding box (제주 남단 ~ 북단, 서해 ~ 동해/울릉·독도 포함)
export const KOREA_BBOX = { minLat: 33, maxLat: 39, minLng: 124, maxLng: 132 };

// 좌표가 한국 영역이면 true
export const isDomestic = (lat, lng) => {
    if (lat == null || lng == null) return false;
    let la = Number(lat), lo = Number(lng);
    if (Number.isNaN(la) || Number.isNaN(lo)) return false;
    return la >= KOREA_BBOX.minLat && la <= KOREA_BBOX.maxLat
        && lo >= KOREA_BBOX.minLng && lo <= KOREA_BBOX.maxLng;
};
